angular.
module("digiexam.exam").
directive("examStudentsSelector", function examStudentsSelectorService() {
	"use strict";

	var directiveName = "examStudentsSelector";
	var uniqueId = 0;

	return {
		restrict: "E",
		scope: {
			students: "<",
			selection: "=",
			anonymous: "=",
			disabledStudentCodes: "=",
			titleKey: "@",
			extendedProperties: "=", //Use firstname, lastname
		},
		templateUrl: "tmpl/student/exam-students-selector-directive.html",
		replace: true,
		link: link,
		controller: "ExamStudentsSelectorController",
	};

	function link($scope) {
		$scope.directiveId = directiveName + "-" + uniqueId++;
	}
});
